export const MODE_LIST = 'list';
export const MODE_VIEW = 'view';
export const MODE_TO_ORDER_CART = 'to_order_cart';
export const MODE_TO_ORDER_CHECKOUT = 'to_order_checkout';